import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {FPNetDate, ObjectFactory} from "@commons/types";
import {DateTimeUtils} from "@commons/utils/DateTimeUtils";
import {DateTime} from "luxon";
import {merge} from "lodash";

export interface TaskServizi extends URIAndTrace {
    idAziendaMaster: number | null,
    idAzienda: number | null,
    anno: number | null,
    mese: number | null,
    ggIniziale: number | null,
    ggFinale: number | null,
    eseguiPer: 'TUTTI' | 'SPACCATURA' | 'SINGOLO' | 'AGENZIA' | 'CDIC' | null,
    idDipSingolo: number | null,
    agenziaInterinale: number | null,
    spaccatura: 'NESSUNA' | 'GIORNALIERA' | 'SETTIMANALE' | 'MENSILE' | null,
    codiceCDIC: string | null,
    dataIniziale: FPNetDate,
    dataFinale: FPNetDate,
    result: string | null, // String, può contenere un messaggio che descrive il risultato del task, es. "Non è stato trovato alcun giustificativo!" per la stampa dei giustificativi...
    stato: 'IN_ATTESA' | 'IN_ESECUZIONE' | 'COMPLETATO' | 'IN_PAUSA' | 'ANNULLATO' | 'IN_ERRORE' | null,
}

export class TaskServizi {
    static factory: ObjectFactory<TaskServizi> = (json?) => {
        const task = merge<TaskServizi, Partial<TaskServizi> | undefined>({
            idAziendaMaster: null,
            idAzienda: null,
            anno: null,
            mese: null,
            ggIniziale: null,
            ggFinale: null,
            eseguiPer: null,
            idDipSingolo: null,
            agenziaInterinale: null,
            spaccatura: null,
            codiceCDIC: null,
            dataIniziale: null,
            dataFinale: null,
            result: null,
            stato: null,
            URI: null,
        }, json);

        return TaskServizi.normalizza(task);
    }
    static normalizza = (task: TaskServizi) => {
        // Normalizzo dataInziale
        if (task.ggIniziale && !task.dataIniziale) {
            task.dataIniziale = String(task.anno).padStart(4, "0") + '-' + String(task.mese).padStart(2, "0") + '-' + String(task.ggIniziale).padStart(2, "0"); // yyyy-MM-dd
        }
        // Normalizzo dataFinale
        if (task.ggFinale && !task.dataFinale) {
            task.dataFinale = String(task.anno).padStart(4, "0") + '-' + String(task.mese).padStart(2, "0") + '-' + String(task.ggFinale).padStart(2, "0"); // yyyy-MM-dd
        }
        return task;
    }
    static IsBetweenDate = (that: TaskServizi, dtGiornata: FPNetDate) => {
        return DateTimeUtils.isBetween({
            validitaInizio: that.dataIniziale,
            validitaFine: that.dataFinale
        }, (dtGiornata ? DateTime.fromISO(dtGiornata) : undefined));
    };
}